import { render, staticRenderFns } from "./bulk_option.vue?vue&type=template&id=2af9ece2&scoped=true&"
import script from "./bulk_option.vue?vue&type=script&lang=js&"
export * from "./bulk_option.vue?vue&type=script&lang=js&"
import style0 from "./bulk_option.vue?vue&type=style&index=0&id=2af9ece2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af9ece2",
  null
  
)

export default component.exports